import Swal from 'sweetalert2';

const showAccessDeniedAlert = (navigate) => {
    Swal.fire({
        title: 'Access Denied',
        text: "You don’t have permission to access this page. Please contact your administrator to request access.",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#10B981',
        cancelButtonColor: '#EF3D50',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed) {
            navigate(-1);
        }
    });
};

export default showAccessDeniedAlert;